import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDot = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 5 6",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M2.304 5.43199C1.024 5.43199 0 4.40799 0 2.99999C0 1.59199 1.024 0.567993 2.304 0.567993C3.584 0.567993 4.608 1.59199 4.608 2.99999C4.608 4.40799 3.584 5.43199 2.304 5.43199Z",
		fill: "currentColor"
	})
});
export default SvgDot;
